import { setCookie } from "./setCookie";
import {
  IS_LOGGED_IN_COOKIE_NAME,
  REFRESH_TOKEN_EXPIRE_TIME_MS,
  VERIFYING_TOKEN_COOKIE_NAME,
} from "../../vars";

/**
 * Set cookie {VERIFYING_TOKEN_COOKIE_NAME, IS_LOGGED_IN_COOKIE_NAME} for auth state useUser context
 * @param expireAccessValueDateSec - Access token expire date in seconds
 */
export const setAuthCookie = (expireAccessValueDateSec: number): void => {
  setCookie(VERIFYING_TOKEN_COOKIE_NAME, `true`, {
    expires: new Date(expireAccessValueDateSec * 1000),
  });
  setCookie(IS_LOGGED_IN_COOKIE_NAME, `true`, {
    expires: new Date(Date.now() + REFRESH_TOKEN_EXPIRE_TIME_MS),
  });
};
